import TrackerDataTableItemEdit from '@/applications/scrum/components/TrackerDataTable/TrackerDataTableItemEdit/TrackerDataTableItemEdit.js'

export default {
  name: 'PropositionTableEdit',
  mixins: [TrackerDataTableItemEdit],

  methods: {
    async afterEditHook (savedModel) {
      const workpackages = await this.loadWorkpackages()
      await this.verifyWorkPackageConsistency(savedModel, workpackages)
    },

    // Load WPs
    async loadWorkpackages () {
      const url = `/api/${this.applicationId}/tracker/${this.trackerTypeId}/${this.trackerId}/workpackage`

      try {
        const response = await this.$axios.get(url, this.$axios.agilisRequestConfig(url))
        return response.data
      } catch (error) {
        console.error('PropositionTableEdit: error loading workpackages')
        this.notifyError(error)
        return []
      }
    },

    // Loop on WPs and update where dates are out-of-sync
    async verifyWorkPackageConsistency (savedModel, workpackages) {
      const pStartDate = savedModel.startDate
      const pEndDate = savedModel.endDate

      const allUpdates = []
      workpackages.forEach(wp => {
        if (wp.startDate !== pStartDate || wp.endDate !== pEndDate) {
          console.warn(`Will updated dates of workpackage "${wp.id}"`)
          const fixedWp = Object.assign({}, wp, { startDate: pStartDate, endDate: pEndDate })
          const url = `/api/${this.applicationId}/tracker/${this.trackerTypeId}/${this.trackerId}/workpackage/${fixedWp.id}`

          const updatePromise = this.$axios
            .put(url, fixedWp, this.$axios.agilisRequestConfig(url))
          allUpdates.push(updatePromise)
        }
      })
      Promise.all(allUpdates)
    }
  }
}
